import {boardQueryResut} from "../pages/board";

export const checkBoardQueryType = (result: unknown): boardQueryResut[] => {
  (result as boardQueryResut[])?.forEach(obj => {
    if (!obj.id || !obj.userId || !obj.pageInformations)
      throw new Error("Error in object keys");
  })
  return result as boardQueryResut[];
}
